import { Routes } from '@angular/router';

import { BlankLayoutComponent } from './common/layouts/blankLayout.component';
import { BasicLayoutComponent } from './common/layouts/basicLayout.component';
import { PrepareGuard } from 'app/core/prepare.guard';
import { HomeComponent } from 'app/common/layouts/home/home.component';
import { LoginComponent } from 'app/common/layouts/login/login.component';
import { AuthGuard } from './core/auth.guard';

export const ROUTES: Routes = [
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    {
        path: '',
        component: BasicLayoutComponent,
        children: [
            { path: 'home', component: HomeComponent, data: { title: 'Home' }, canActivate: [AuthGuard, PrepareGuard] },
            { path: 'login', component: LoginComponent, data: { title: 'Login' } },
        ],
    },

    // Handle all other routes
    { path: '**', redirectTo: 'home' },
];
